import { useEffect, useState } from "react";
import { useTransactionCategories } from "../../hooks/useTransactionCategories";
import { MonthlyTransactionFetchParams, TransactionCategory, TransactionCategoryType } from "../../models/types";
import CustomSwitch from "../Switch";
import CustomSelectDropdown from "./CustomSelectDropdown";
import PaidFilterDropdown from "./PaidFilterDropdown";
import TransactionTypeFilterDropdown from "./TransactionTypeFilterDropdown";

type MonthlyBudgetFiltersProps = {
    filters: MonthlyTransactionFetchParams;
    setFilters: (filters: MonthlyTransactionFetchParams) => void;
}
export const MonthlyBudgetFilters = ({ filters, setFilters }: MonthlyBudgetFiltersProps) => {
    const [selectedCategory, setSelectedCategory] = useState<TransactionCategory | null>(null);
    const [selectedType, setSelectedType] = useState<TransactionCategoryType | null>(null);
    const [selectedTransactionType, setSelectedTransactionType] = useState<"Todos" | "Receita" | "Despesa">("Todos");
    const [paid, setPaid] = useState<"Todos" | "Pago" | "Não pago">("Todos");
    const [includeCreditCard, setIncludeCreditCard] = useState<boolean>(false);

    useEffect(() => {
        setFilters({
            ...filters,
            category: selectedCategory?.id,
            category_type: selectedType?.id,
            paid: paid === "Pago" ? true : paid === "Não pago" ? false : undefined,
            type: selectedTransactionType === "Receita" ? "credit" : selectedTransactionType === "Despesa" ? "debit" : undefined,
            include_credit_card: includeCreditCard,
        })
    }, [selectedCategory, selectedType, paid, selectedTransactionType, includeCreditCard])

    return <div className="flex flex-col md:flex-row gap-2 w-full items-start md:items-center" style={{ position: 'relative', zIndex: 30 }}>
        <TransactionTypeFilterDropdown onChange={setSelectedTransactionType} value={selectedTransactionType} label="Tipo" />
        <PaidFilterDropdown onChange={setPaid} value={paid} label="Status" />
        <CustomSelectDropdown<TransactionCategory, MonthlyTransactionFetchParams>
            params={{ page_size: 100 }}
            label="Categoria"
            useGetOptions={useTransactionCategories}
            nameKey="name" onChange={setSelectedCategory} selected={selectedCategory}
            className="w-full md:max-w-xs"
        />
        <div className="flex flex-col gap-1 items-start">
            <div className="text-sm font-medium leading-6 text-gray-900">Cartão de crédito</div>
            <div className="flex items-center gap-2 px-3 py-2 border border-primaryBorder rounded-md bg-white">
                <CustomSwitch
                    visible={includeCreditCard}
                    setVisible={setIncludeCreditCard}
                    label="Incluir transações do cartão de crédito"
                />
                <label className="text-xs font-medium text-primaryText whitespace-nowrap">
                    Visualizar lançamentos
                </label>
            </div>
        </div>
    </div>
}